module.exports = __webpack_public_path__ + "static/media/munch16.4a7a8d9b.wav";